import { Typography, Button, Alert } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

const DetailAlerts = ({ id, insertData, initialValues, updateData }) => {
  return (
    <div className="w-full block">
      <Typography variant="subtitle1">
        {id < 1 && <span>Kategori Ekle</span>}
        {id > 0 && <span>{initialValues.title} Kategorisi Düzenle</span>}
      </Typography>
      {insertData.data && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="success">Kategori Ekleme İşlemi Başarılı...</Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href="/categories/0"
          >
            Geri Dön
          </Button>
        </div>
      )}
      {insertData.isError && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="error">
            Kategori Ekleme Sırasında Bir Hata oluşu. Lütfen Tekrar Deneyiniz!
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href="/categories/0"
          >
            Geri Dön
          </Button>
        </div>
      )}
      {updateData.isSuccess && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="success">
            {initialValues.title} Kategorisi Başarıyla Güncellendi ...
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href="/categories/0"
          >
            Geri Dön
          </Button>
        </div>
      )}
      {updateData.isError && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="error">
            {initialValues.title} Kategorisi Güncellenirken Bir Hata Oluştu!
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href="/categories/0"
          >
            Geri Dön
          </Button>
        </div>
      )}
    </div>
  );
};

export default DetailAlerts;
